export default function (element, data) {
    let closeBtns = element.querySelectorAll('.selected__brands_item');

    closeBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const removeId = Number(this.dataset.id);

            const url = window.location.pathname;

            const match = url.match(/\/brands\/([^\/]+)/);

            if (!match) return;

            let ids = match[1]
                .split(',')
                .map(Number)
                .filter(id => !isNaN(id));

            ids = ids.filter(id => id !== removeId);

            let newUrl = '';

            if (ids.length === 0) {
                newUrl = url.replace(/\/brands\/[^\/]+/, '');
            } else {
                const newIds = ids.sort((a, b) => a - b).join(',');
                newUrl = url.replace(/\/brands\/[^\/]+/, `/brands/${newIds}`);
            }
            
            window.location = newUrl;
        });
    });
};